module.exports = __webpack_public_path__ + "img/navRightBottom.4beffcef.png";